import { useEffect, useState } from 'react';
import {
  EMPTY_PLATFORM_LEGAL_INFO,
  loadPlatformLegalInfo,
  type PlatformLegalInfo,
} from '../services/platformLegalInfoService';

export function usePlatformLegalInfo(): PlatformLegalInfo {
  const [info, setInfo] = useState<PlatformLegalInfo>(EMPTY_PLATFORM_LEGAL_INFO);

  useEffect(() => {
    let active = true;
    loadPlatformLegalInfo().then((value) => {
      if (active) setInfo(value);
    });
    return () => {
      active = false;
    };
  }, []);

  return info;
}
